<template>
  <div class="p-3 client-side-tabs">
    <c-tabs variant="pills" vertical>
      <c-tab active title="Content">
        <email-content :client="client"></email-content>
      </c-tab>
      <c-tab title="Schedule">
        <schedule :client="client"></schedule>
      </c-tab>
      <c-tab title="Preview">
        <preview-email :client="client"></preview-email>
        <hr />
        <test-email :client="client"></test-email>
      </c-tab>
      <c-tab title="Logs">
        <email-logs :client="client"></email-logs>
      </c-tab>
    </c-tabs>
  </div>
</template>

<script>
import TestEmail from './test';
import PreviewEmail from './preview';
import EmailContent from './content';
import Schedule from './schedule';
import EmailLogs from '../../email-logs';

export default {
  components: {
    TestEmail,
    PreviewEmail,
    Schedule,
    EmailContent,
    EmailLogs,
  },

  props: {
    client: Object,
  },

  data() {
    return {};
  },
  methods: {},
};
</script>

<style lang="scss" scoped="">
.c-dark-theme {
  .client-side-tabs {
    background-color: #23242d;
  }
}
</style>
